import type { ReactNode } from "react"

interface PageEmptyProps {
  title: string
  description?: ReactNode
  action?: ReactNode
  icon?: ReactNode
  /** `ruled`: sin caja, alineado a la izquierda y con reglas, como las listas de la página. */
  variant?: "card" | "ruled"
}

export function PageEmpty({ title, description, action, icon, variant = "card" }: PageEmptyProps) {
  if (variant === "ruled") {
    return (
      <div className="motion-rise flex w-full flex-col items-start gap-2 border-y border-border py-8">
        <h2 className="text-lg font-semibold tracking-tight text-foreground">{title}</h2>
        {description ? <p className="max-w-prose text-sm text-muted-foreground">{description}</p> : null}
        {action ? <div className="mt-2 flex flex-wrap items-center gap-2">{action}</div> : null}
      </div>
    )
  }
  return (
    <div className="motion-rise flex flex-col items-center gap-3 rounded-xl border border-border bg-card px-6 py-10 text-center">
      {icon ? <div className="text-muted-foreground" aria-hidden="true">{icon}</div> : null}
      <p className="text-base font-semibold text-foreground">{title}</p>
      {description ? <p className="max-w-prose text-sm text-muted-foreground">{description}</p> : null}
      {action ? <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{action}</div> : null}
    </div>
  )
}
